'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/vasternorrlands-museum/public/wp-content/themes/murberget/node_modules/promise/index.js
// module id = 156
// module chunks = 0